import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';

import { TranslationModule } from '@lib/translation';
import { SnButtonModule } from '@lib/ui/button';
import { SnIconModule } from '@lib/ui/icon';
import { SnTooltipModule } from '@lib/ui/tooltip';

import { SearchbarComponent } from './components';
import { NavigableListItemDirective } from './directives/focusable-item.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    MatListModule,

    OverlayModule,

    SnButtonModule,
    SnTooltipModule,
    SnIconModule,
    TranslationModule,
  ],
  exports: [SearchbarComponent],
  declarations: [NavigableListItemDirective, SearchbarComponent],
})
export class SnSearchbarModule {}
